import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';

// page
import Layout from '@/views/layout/layout.vue';
// routing
import LayoutRouting from '@/views/layout/layout-routing.js';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/logon'
    },
    {
      path: '/app',
      name: 'app',
      component: Layout,
      meta: {
        title: '首页'
      },
      redirect: '/app/index',
      children: LayoutRouting
    },
    {
      path: '/logon',
      name: 'logon',
      component: () => import('@/views/logon/index.vue'),
      meta: {
        title: '登录'
      }
    }
  ]
});

// 针对于路由跳转相同的地址添加catch捕获异常
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

router.beforeEach((to, from, next) => {
  if (to.path === '/app/register') {
    const info = {
      show: true,
      step: 1
    };
    store.commit('SET_OCR_BOX_INFO', info);
  } else {
    const info = {
      show: false,
      step: 1
    };
    store.commit('SET_OCR_BOX_INFO', info);
  }
  next();
});
export default router;
